<div class="px-1">
    <!-- <h5 class="m-0"><b>{{ type() }}</b></h5> -->
    <div class="d-flex justify-content-between">
         <div class="d-flex" style="gap: 8px;">
            <kendo-label [text]="'Terminal / Anchorage Area / Pilot Station'"
                         [ngClass]="stopFieldIsValid('startLocationId') ? 'text-grey' : 'text-red'">
                <kendo-combobox [data]="terminalsDropdown()"
                                [(value)]="state().selectedTerminal"
                                (valueChange)="onTerminalChange()"
                                [valuePrimitive]="false"
                                [valueField]="'id'"
                                [textField]="'name'"
                                [clearButton]="false"
                                [fillMode]="'outline'"
                                placeholder="Select location"
                                [popupSettings]="{ width: 'auto'}"
                                [virtual]="true"
                                [class.border-red]="!stopFieldIsValid('startLocationId')">
                </kendo-combobox>
            </kendo-label>
            <kendo-label [text]="'Berth / Anchorage'"
                         class="text-grey">
                <kendo-combobox [data]="berthDropdown()"
                                [(value)]="state().selectedBerth"
                                (valueChange)="onLocationChange()"
                                [valuePrimitive]="false"
                                [valueField]="'id'"
                                [textField]="'name'"
                                [clearButton]="false"
                                [fillMode]="'outline'"
                                placeholder="Select location"
                                [popupSettings]="{ width: 'auto'}"
                                [virtual]="true">
                </kendo-combobox>
            </kendo-label>
            <kendo-label text="Tug Organization"
                        class="text-grey">
                <kendo-combobox [data]="tugOrganizations()"
                                [value]="arrivalMovement()?.tugOrganizationId"
                                (valueChange)="updateArrivalMovement('tugOrganizationId', $event)"
                                [valuePrimitive]="true"
                                [valueField]="'id'"
                                [textField]="'name'"
                                [clearButton]="false"
                                [placeholder]="'-'"
                                [virtual]="true"
                                [popupSettings]="{ width: 'auto'}"
                                [fillMode]="'outline'">
                </kendo-combobox>
            </kendo-label>
            <kendo-label text="Launch Organization"
                        class="text-grey">
                <kendo-combobox [data]="launchOrganizations()"
                                [value]="arrivalMovement()?.launchOrganizationId"
                                (valueChange)="updateArrivalMovement('launchOrganizationId', $event)"
                                [valuePrimitive]="true"
                                [valueField]="'id'"
                                [textField]="'name'"
                                [clearButton]="false"
                                [placeholder]="'-'"
                                [virtual]="true"
                                [popupSettings]="{ width: 'auto'}"
                                [fillMode]="'outline'">
                </kendo-combobox>
            </kendo-label>
         </div>

        <!-- <div class="d-inline-flex align-items-center border px-3 py-1 border-radius-15 border-blue text-blue align-self-start">
            <button kendoButton icon="trash" class="withdraw" (click)="onWithdraw()">
                <span class="text-blue">WITHDRAW EVENT</span>
            </button>
        </div> -->
    </div>

    <div class="row">
        <div class="col-9">
            <div class="mt-4">
                <div>
                    <div class="d-flex justify-content-between">
                        <div class="d-flex">
                            <h3 class="m-0 pr-1"><b>ARRIVAL</b></h3>
                            <div class="mx-1">
                                <pmis3-vessel-visit-detail-movement-authority-status [authorityName]="'VFPA'"
                                                                                    [statusId]="arrivalMovement()?.vfpaStatus">
                                </pmis3-vessel-visit-detail-movement-authority-status>
                                <pmis3-vessel-visit-detail-movement-authority-status [authorityName]="'PPA'"
                                                                                    [statusId]="arrivalMovement()?.ppaStatus">
                                </pmis3-vessel-visit-detail-movement-authority-status>
                            </div>
                            <pmis3-vessel-visit-detail-transit-status-picker [statusId]="arrivalMovement()?.statusId"
                                                                             (selectedStatus)="updateArrivalMovement('statusId', $event)"
                                                                             class="mx-1">
                            </pmis3-vessel-visit-detail-transit-status-picker>
                        </div>
                        <div>
                            <button kendoButton
                                    (click)="toggleShowArrivalCargo()"
                                    [themeColor]="'primary'"
                                    style="border-radius: 20px;"
                                    [disabled]="arrivalButtonDisabled()"
                                    [fillMode]="showCargoState().showArrivalCargo() ? 'solid' : 'outline'">
                                {{ arrivalButtonText() }}
                            </button>
                        </div>
                    </div>
                    @if (showCargoState().showArrivalCargo()) {
                    <div class="d-flex flex-column">
                        @for (cargo of state().arrivalCargoes(); track $index; let i = $index) {
                            <pmis3-vessel-visit-detail-movement-cargo *ngIf="!cargo.isDeleted"
                                                                      class="mb-2"
                                                                      [cargo]="cargo"
                                                                      (cargoChange)="onArrivalCargoChange($event, i)">
                            </pmis3-vessel-visit-detail-movement-cargo>
                        }
                        <button kendoButton
                                icon="plus"
                                (click)="onAddArrivalCargo()">
                            add cargo
                        </button>
                    </div>
                    } @else {
                        <div style="display: grid; grid-template-columns: repeat(4, 1fr); grid-template-rows: auto; gap: 12px;">
                            <div>
                                <kendo-label [text]="estimatedStartTimeLabel()"
                                            [ngClass]="arrivalMovementFieldIsValid('estimatedEndTime') ? 'text-grey' : 'text-red'">
                                    <kendo-datetimepicker placeholder="Choose a date"
                                                        [value]="estimatedStartTime()"
                                                        (valueChange)="updateArrivalMovement('estimatedEndTime', $event)"
                                                        [fillMode]="'outline'"
                                                        [format]="dateFormat"
                                                        [class.border-red]="!arrivalMovementFieldIsValid('estimatedEndTime')">
                                    </kendo-datetimepicker>
                                </kendo-label>
                            </div>
                            <div>
                                <kendo-label [text]="startTimeLabel()"
                                             [ngClass]="arrivalMovementFieldIsValid('endTime') ? 'text-grey' : 'text-red'">
                                    <kendo-datetimepicker placeholder="Choose a date"
                                                        [value]="startTime()"
                                                        (valueChange)="updateArrivalMovement('endTime', $event)"
                                                        [fillMode]="'outline'"
                                                        [format]="dateFormat">
                                    </kendo-datetimepicker>
                                </kendo-label>
                            </div>
                            <div>
                                <kendo-label [ngClass]="arrivalMovementFieldIsValid('loadedStatus') ? 'text-grey' : 'text-red'"
                                            text="Loaded Status*">
                                    <kendo-combobox [data]="vesselLadenStatus()"
                                                    [value]="arrivalMovement()?.loadedStatus"
                                                    (valueChange)="updateArrivalMovement('loadedStatus', $event)"
                                                    [valuePrimitive]="true"
                                                    [textField]="'name'"
                                                    [valueField]="'id'"
                                                    [clearButton]="false"
                                                    [placeholder]="'-'"
                                                    [popupSettings]="{ width: 'auto'}"
                                                    [fillMode]="'outline'"
                                                    [class.border-red]="!arrivalMovementFieldIsValid('loadedStatus')">
                                    </kendo-combobox>
                                </kendo-label>
                            </div>
                            <div>
                                <kendo-label text="Max. Displacement"
                                            class="text-grey">
                                    <kendo-numerictextbox [spinners]="false"
                                                        [value]="arrivalMovement()?.maxDisplacement"
                                                        (valueChange)="updateArrivalMovement('maxDisplacement', $event)"
                                                        [fillMode]="'outline'"
                                                        [placeholder]="'-'">
                                    </kendo-numerictextbox>
                                </kendo-label>
                            </div>
                            <div style="grid-column: 1 / 3;">
                                <kendo-label text="Purpose"
                                            class="text-grey">
                                    <kendo-multiselect [data]="vesselActivityPurposes()"
                                                    [(value)]="state().selectedPurposesId"
                                                    [valuePrimitive]="true"
                                                    [textField]="'name'"
                                                    [valueField]="'id'"
                                                    (valueChange)="onPurposesChange()"
                                                    [fillMode]="'outline'"
                                                    [popupSettings]="{ width: 'auto'}"
                                                    [placeholder]="'-'">
                                    </kendo-multiselect>
                                </kendo-label>
                            </div>
                            <div style="grid-column: 3 / 5;">
                                <kendo-label text="Vessel Orientation"
                                            class="text-grey">
                                    <kendo-combobox [data]="vesselOrientations()"
                                                    [value]="stop()?.vesselOrientation"
                                                    (valueChange)="updateStop('vesselOrientation', $event)"
                                                    [valuePrimitive]="true"
                                                    [textField]="'name'"
                                                    [valueField]="'id'"
                                                    [clearButton]="false"
                                                    [placeholder]="'-'"
                                                    [virtual]="true"
                                                    [popupSettings]="{ width: 'auto'}"
                                                    [fillMode]="'outline'">
                                    </kendo-combobox>
                                </kendo-label>
                            </div>
                            <div>
                                <kendo-label  [ngClass]="arrivalMovementFieldIsValid('foreDraft') ? 'text-grey' : 'text-red'"
                                            text="Draught Forward (m)*">
                                    <kendo-numerictextbox [spinners]="false"
                                                        [value]="arrivalMovement()?.foreDraft"
                                                        (valueChange)="updateArrivalMovement('foreDraft', $event)"
                                                        [fillMode]="'outline'"
                                                        [placeholder]="'-'"
                                                        [class.border-red]="!arrivalMovementFieldIsValid('foreDraft')">
                                    </kendo-numerictextbox>
                                </kendo-label>
                            </div>
                            <div>
                                <kendo-label text="Draught Mid (m)*"
                                            [ngClass]="arrivalMovementFieldIsValid('midDraft') ? 'text-grey' : 'text-red'">
                                    <kendo-numerictextbox [spinners]="false"
                                                        [value]="arrivalMovement()?.midDraft"
                                                        (valueChange)="updateArrivalMovement('midDraft', $event)"
                                                        [fillMode]="'outline'"
                                                        [placeholder]="'-'"
                                                        [class.border-red]="!arrivalMovementFieldIsValid('midDraft')">
                                    </kendo-numerictextbox>
                                </kendo-label>
                            </div>
                            <div>
                                <kendo-label text="Draught Aft (m)*"
                                            [ngClass]="arrivalMovementFieldIsValid('aftDraft') ? 'text-grey' : 'text-red'">
                                    <kendo-numerictextbox [spinners]="false"
                                                        [value]="arrivalMovement()?.aftDraft"
                                                        (valueChange)="updateArrivalMovement('aftDraft', $event)"
                                                        [fillMode]="'outline'"
                                                        [placeholder]="'-'"
                                                        [class.border-red]="!arrivalMovementFieldIsValid('aftDraft')">
                                    </kendo-numerictextbox>
                                </kendo-label>
                            </div>
                            <div>
                                <kendo-label text="Air Draught (m)*"
                                            [ngClass]="arrivalMovementFieldIsValid('airDraft') ? 'text-grey' : 'text-red'">
                                    <kendo-numerictextbox [spinners]="false"
                                                        [value]="arrivalMovement()?.airDraft"
                                                        (valueChange)="updateArrivalMovement('airDraft', $event)"
                                                        [fillMode]="'outline'"
                                                        [placeholder]="'-'"
                                                        [class.border-red]="!arrivalMovementFieldIsValid('airDraft')">
                                    </kendo-numerictextbox>
                                </kendo-label>
                            </div>
                            <div style="grid-column: 1 / 5;">
                                <kendo-label [text]="'Remarks'"
                                            class="text-grey">
                                    <kendo-textarea [rows]="4"
                                                    [fillMode]="'outline'"
                                                    [value]="arrivalMovement()?.remarks ?? ''"
                                                    (valueChange)="updateArrivalMovement('remarks', $event)"
                                                    class="w-100 line-height-1-half"
                                                    [placeholder]="'Remarks'">
                                    </kendo-textarea>
                                </kendo-label>
                            </div>
                        </div>
                    }  
                </div>
            </div>

            <div class="mt-5">
                <div>
                    <div class="d-flex justify-content-between">
                        <div class="d-flex">
                            <h3 class="m-0 pr-1"><b>DEPARTURE</b></h3>
                            <div class="mx-1">
                                <pmis3-vessel-visit-detail-movement-authority-status [authorityName]="'VFPA'"
                                                                                     [statusId]="departureMovement()?.vfpaStatus">
                                </pmis3-vessel-visit-detail-movement-authority-status>
                                <pmis3-vessel-visit-detail-movement-authority-status [authorityName]="'PPA'"
                                                                                     [statusId]="departureMovement()?.ppaStatus">
                                </pmis3-vessel-visit-detail-movement-authority-status>
                            </div>
                            <pmis3-vessel-visit-detail-transit-status-picker [statusId]="departureMovement()?.statusId"
                                                                             (selectedStatus)="updateDepartureMovement('statusId', $event)"
                                                                             class="mx-1">
                            </pmis3-vessel-visit-detail-transit-status-picker>
                            
                        </div>
                        <div>
                            <button kendoButton
                                    (click)="toggleShowDepartureCargo()"
                                    [themeColor]="'primary'"
                                    style="border-radius: 20px;"
                                    [disabled]="departureButtonDisabled()"
                                    [fillMode]="showCargoState().showDepartureCargo() ? 'solid' : 'outline'">
                                {{ departureButtonText() }}
                            </button>
                        </div>
                    </div>
                    @if (showCargoState().showDepartureCargo()) {
                        <div class="d-flex flex-column">
                        @for (cargo of state().departureCargoes(); track $index; let i = $index) {
                            <pmis3-vessel-visit-detail-movement-cargo *ngIf="!cargo.isDeleted"
                                                                      class="mb-2"
                                                                      [cargo]="cargo"
                                                                      (cargoChange)="onDepartureCargoChange($event, i)">
                            </pmis3-vessel-visit-detail-movement-cargo>
                        }
                        <button kendoButton
                                icon="plus"
                                (click)="onAddDepartureCargo()">
                            add cargo
                        </button>
                    </div>
                    } @else {
                        <div style="display: grid; grid-template-columns: repeat(4, 1fr); grid-template-rows: auto; gap: 12px;">
                            <div>
                                <kendo-label [text]="estimatedEndTimeLabel()"
                                            [ngClass]="stopFieldIsValid('estimatedEndTime') ? 'text-grey' : 'text-red'">
                                    <kendo-datetimepicker placeholder="Choose a date"
                                                        [value]="estimatedEndTime()"
                                                        (valueChange)="updateStop('estimatedEndTime', $event)"
                                                        [fillMode]="'outline'"
                                                        [format]="dateFormat"
                                                        [class.border-red]="!stopFieldIsValid('estimatedEndTime')">
                                    </kendo-datetimepicker>
                                </kendo-label>
                            </div>
                            <div>
                                <kendo-label [text]="endTimeLabel()"
                                             class="text-grey">
                                    <kendo-datetimepicker placeholder="Choose a date"
                                                        [value]="endTime()"
                                                        (valueChange)="updateStop('endTime', $event)"
                                                        [fillMode]="'outline'"
                                                        [format]="dateFormat">
                                    </kendo-datetimepicker>
                                </kendo-label>
                            </div>
                            <div>
                                <kendo-label text="Loaded Status*"
                                            [ngClass]="departureMovementFieldIsValid('loadedStatus') ? 'text-grey' : 'text-red'">
                                    <kendo-combobox [data]="vesselLadenStatus()"
                                                    [value]="departureMovement()?.loadedStatus"
                                                    (valueChange)="updateDepartureMovement('loadedStatus', $event)"
                                                    [valuePrimitive]="true"
                                                    [textField]="'name'"
                                                    [valueField]="'id'"
                                                    [clearButton]="false"
                                                    [placeholder]="'-'"
                                                    [popupSettings]="{ width: 'auto'}"
                                                    [fillMode]="'outline'"
                                                    [class.border-red]="!departureMovementFieldIsValid('loadedStatus')" >
                                                    
                                    </kendo-combobox>
                                </kendo-label>
                            </div>
                            <div>
                                <kendo-label text="Max. Displacement"
                                            class="text-grey">
                                    <kendo-numerictextbox [spinners]="false"
                                                        [value]="departureMovement()?.maxDisplacement"
                                                        (valueChange)="updateDepartureMovement('maxDisplacement', $event)"
                                                        [fillMode]="'outline'"
                                                        [placeholder]="'-'">
                                    </kendo-numerictextbox>
                                </kendo-label>
                            </div>
                            <div>
                                <kendo-label text="Draught Forward (m)*"
                                            [ngClass]="departureMovementFieldIsValid('foreDraft') ? 'text-grey' : 'text-red'">
                                    <kendo-numerictextbox [spinners]="false"
                                                        [value]="departureMovement()?.foreDraft"
                                                        (valueChange)="updateDepartureMovement('foreDraft', $event)"
                                                        [fillMode]="'outline'"
                                                        [placeholder]="'-'"
                                                        [class.border-red]="!departureMovementFieldIsValid('foreDraft')">
                                    </kendo-numerictextbox>
                                </kendo-label>
                            </div>
                            <div>
                                <kendo-label text="Draught Mid (m)*"
                                            [ngClass]="departureMovementFieldIsValid('midDraft') ? 'text-grey' : 'text-red'">
                                    <kendo-numerictextbox [spinners]="false"
                                                        [value]="departureMovement()?.midDraft"
                                                        (valueChange)="updateDepartureMovement('midDraft', $event)"
                                                        [fillMode]="'outline'"
                                                        [placeholder]="'-'"
                                                        [class.border-red]="!departureMovementFieldIsValid('midDraft')">
                                    </kendo-numerictextbox>
                                </kendo-label>
                            </div>
                            <div>
                                <kendo-label text="Draught Aft (m)*"
                                            [ngClass]="departureMovementFieldIsValid('aftDraft') ? 'text-grey' : 'text-red'">
                                    <kendo-numerictextbox [spinners]="false"
                                                        [value]="departureMovement()?.aftDraft"
                                                        (valueChange)="updateDepartureMovement('aftDraft', $event)"
                                                        [fillMode]="'outline'"
                                                        [placeholder]="'-'"
                                                        [class.border-red]="!departureMovementFieldIsValid('aftDraft')">
                                    </kendo-numerictextbox>
                                </kendo-label>
                            </div>
                            <div>
                                <kendo-label text="Air Draught (m)*"
                                            [ngClass]="departureMovementFieldIsValid('airDraft') ? 'text-grey' : 'text-red'">
                                    <kendo-numerictextbox [spinners]="false"
                                                        [value]="departureMovement()?.airDraft"
                                                        (valueChange)="updateDepartureMovement('airDraft', $event)"
                                                        [fillMode]="'outline'"
                                                        [placeholder]="'-'"
                                                        [class.border-red]="!departureMovementFieldIsValid('airDraft')">
                                    </kendo-numerictextbox>
                                </kendo-label>
                            </div>
                            <div style="grid-column: 1 / 5;">
                                <kendo-label [text]="'Remarks'"
                                            class="text-grey">
                                    <kendo-textarea [rows]="4"
                                                    [fillMode]="'outline'"
                                                    [value]="departureMovement()?.remarks ?? ''"
                                                    (valueChange)="updateDepartureMovement('remarks', $event)"
                                                    class="w-100 line-height-1-half"
                                                    [placeholder]="'Remarks'">
                                    </kendo-textarea>
                                </kendo-label>
                            </div>
                        </div>
                    }
                    </div>
                </div>
            </div>

        <div class="col-3">
            <h6 class="mb-2 font-larger-1 line-height-1">SERVICE APPLICATIONS</h6>
            <div class="w-100"
                style="height: 94%;">
                <pmis3-vessel-visit-detail-movement-service-application-picker class="w-100 h-100" 
                                                                            [serviceApplicationsId]="serviceApplicationsId()"
                                                                            (serviceApplicationsIdChange)="onServiceApplicationsIdChange($event)"
                                                                            [wrapperClasses]="'justify-content-start'">
                </pmis3-vessel-visit-detail-movement-service-application-picker>
            </div>
        </div>
    </div>        



</div>

<!-- <div class="d-flex mb-4">
     @if (!isMovement() && vesselActivity()) {
        <div class="col">
            <div class="d-flex mt-2">
                <kendo-label [text]="startTimeLabel()"
                             class="text-grey col-4">
                    <kendo-datetimepicker 
                        placeholder="Choose a date"
                        [value]="startTime()"
                        (valueChange)="onStartTimeChange($event)"
                        [fillMode]="'outline'">
                    </kendo-datetimepicker>
                </kendo-label>
                <kendo-label [text]="endTimeLabel()" 
                             class="text-grey col-4">
                    <kendo-datetimepicker 
                        placeholder="Choose a date"
                        [value]="vesselActivity()?.endTime"
                        (valueChange)="onEndTimeChange($event)"
                        [fillMode]="'outline'">
                    </kendo-datetimepicker>
                </kendo-label>

            </div>
            <div class="d-flex mt-2">
                <kendo-label text="Purpose"
                             class="text-grey">
                    <kendo-multiselect [data]="vesselActivityPurposes()"
                                        [(value)]="selectedPurposesId"
                                        [valuePrimitive]="true"
                                        [textField]="'name'"
                                        [valueField]="'id'"
                                        (valueChange)="onPurposesChange($event)"
                                        [fillMode]="'outline'"
                                        [placeholder]="'-'">
                    </kendo-multiselect>
                </kendo-label>

                <kendo-label text="Vessel Orientation"
                            class="text-grey">
                    <kendo-combobox [data]="vesselOrientations"
                                    [value]="vesselActivity()?.vesselOrientation"
                                    (valueChange)="onVesselOrientationChange($event)"
                                    [valuePrimitive]="true"
                                    [textField]="'name'"
                                    [valueField]="'id'"
                                    [clearButton]="false"
                                    [placeholder]="'-'"
                                    [virtual]="true"
                                    [fillMode]="'outline'">
                    </kendo-combobox>
                </kendo-label>
            </div>
        </div>
        <div class="col">
            <h6 class="my-1 font-larger-1 line-height-1">SERVICE APPLICATIONS</h6>
            <pmis3-vessel-visit-detail-movement-service-application-picker [vesselActivity]="this.vesselActivity()"
                                                                            (vesselActivityChange)="onServiceApplicationChange($event)"></pmis3-vessel-visit-detail-movement-service-application-picker>
        </div>   
     } @else {
        <div class="col">
            <div class="d-flex mt-2">
                <kendo-label text="Loaded Status"
                        class="text-grey">
                    <kendo-combobox [data]="vesselLadenStatus"
                                    [value]="vesselActivity()?.loadedStatus"
                                    (valueChange)="onVesselLadenStatusChange($event)"
                                    [valuePrimitive]="true"
                                    [textField]="'name'"
                                    [valueField]="'id'"
                                    [clearButton]="false"
                                    [placeholder]="'-'"
                                    [virtual]="true"
                                    [fillMode]="'outline'">
                    </kendo-combobox>
            </kendo-label>
            <kendo-label text="Max. Displacement"
                        class="text-grey">
                <kendo-numerictextbox [spinners]="false"
                                    [value]="vesselActivity()?.maxDisplacement"
                                    (valueChange)="onMaxDisplacementChange($event)"
                                    [fillMode]="'outline'"
                                    [placeholder]="'-'">
                </kendo-numerictextbox>
            </kendo-label>
            </div>
            <div class="d-flex mt-2">
                <kendo-label [text]="'Fwd'"
                            class="text-grey">
                    <kendo-numerictextbox [spinners]="false"
                                        [value]="vesselActivity()?.foreDraft"
                                        (valueChange)="onFwdDraftChange($event)"
                                        [fillMode]="'outline'"
                                        [placeholder]="'-'">
                    </kendo-numerictextbox>
                </kendo-label>
                <kendo-label [text]="'Mid'"
                            class="text-grey">
                    <kendo-numerictextbox [spinners]="false"
                                        [value]="vesselActivity()?.midDraft"
                                        (valueChange)="onMidDraftChange($event)"
                                        [fillMode]="'outline'"
                                        [placeholder]="'-'">
                    </kendo-numerictextbox>
                </kendo-label>   
                <kendo-label [text]="'Aft'"
                            class="text-grey">
                    <kendo-numerictextbox [spinners]="false"
                                        [value]="vesselActivity()?.aftDraft"
                                        (valueChange)="onAftDraftChange($event)"
                                        [fillMode]="'outline'"
                                        [placeholder]="'-'">
                    </kendo-numerictextbox>
                </kendo-label>
                <kendo-label [text]="'Air Draft'"
                            class="text-grey">
                    <kendo-numerictextbox [spinners]="false"
                                        [value]="vesselActivity()?.airDraft"
                                        (valueChange)="onAirDraftChange($event)"
                                        [fillMode]="'outline'"
                                        [placeholder]="'-'">
                    </kendo-numerictextbox>
                </kendo-label>
            </div>              
        </div>
        <div class="col">
            <kendo-label [text]="'Remarks'"
                         class="text-grey">
                <kendo-textarea [rows]="4"
                                [fillMode]="'outline'"
                                [value]="vesselActivity()?.remarks ?? ''"
                                (valueChange)="onRemarksChange($event)"
                                class="w-100 line-height-1-half"
                                [placeholder]="'Remarks'">
                </kendo-textarea>
            </kendo-label>
        </div>
     } -->
<!-- <div class="row mx-0">
        <div [ngClass]="isDeparture()? 'col-5' : 'col-2'">
            <div>
                <kendo-label text="Purpose"
                             class="text-grey">
                    <kendo-multiselect [data]="vesselActivityPurposes"
                                       [value]="vesselActivitiesPair().stop?.purposes ?? []"
                                       (valueChange)="onPurposesChange($event)"
                                       [fillMode]="'outline'"></kendo-multiselect>
                </kendo-label>
            </div>
            <div class="mt-3">
                <kendo-label text="Loaded Status"
                             class="text-grey">
                    <kendo-combobox [data]="vesselLadenStatus"
                                    [value]="vesselActivitiesPair().movement.loadedStatus"
                                    (valueChange)="onVesselLadenStatusChange($event)"
                                    [valuePrimitive]="true"
                                    [clearButton]="false"
                                    [placeholder]="'-'"
                                    [virtual]="true"
                                    [fillMode]="'outline'">
                    </kendo-combobox>
                </kendo-label>
            </div>
        </div>
        <div [ngClass]="isDeparture()? 'col-5' : 'col-2'">
            <div class="">
                <kendo-label text="Vessel Orientation"
                             class="text-grey">
                    <kendo-combobox [data]="vesselOrientations"
                                    [value]="vesselActivitiesPair().stop?.vesselOrientation"
                                    (valueChange)="onVesselOrientationChange($event)"
                                    [valuePrimitive]="true"
                                    [clearButton]="false"
                                    [placeholder]="'-'"
                                    [virtual]="true"
                                    [fillMode]="'outline'">
                    </kendo-combobox>
                </kendo-label>
            </div>
            <div class="mt-3">
                <kendo-label text="Max. Displacement"
                             class="text-grey">
                    <kendo-numerictextbox [spinners]="false"
                                          [value]="vesselActivitiesPair().stop?.maxDisplacement"
                                          (valueChange)="onMaxDisplacementChange($event)"
                                          [fillMode]="'outline'">
                    </kendo-numerictextbox>
                </kendo-label>
            </div>
        </div>
        <div class="col-2"
             *ngIf="!isDeparture()">
            <h6 class="my-1 font-larger-1 line-height-1">SA LOCATION</h6>
            <pmis3-vessel-visit-detail-movement-service-application-picker [vesselActivity]="vesselActivitiesPair().stop"
                                                                           (vesselActivityChange)="onServiceApplicationChangeOnStop($event)"></pmis3-vessel-visit-detail-movement-service-application-picker>
        </div>
        <div class="col-2">
            <h6 class="my-1 font-larger-1 line-height-1">SA MOVEMENT</h6>
            <pmis3-vessel-visit-detail-movement-service-application-picker [vesselActivity]="vesselActivitiesPair().movement"
                                                                           (vesselActivityChange)="onServiceApplicationChangeOnMovement($event)"></pmis3-vessel-visit-detail-movement-service-application-picker>
        </div>
        <div *ngIf="!isDeparture()"
             class="col">
            <h6 class="my-1 font-larger-1 line-height-1">ORGANIZATIONS</h6>
            <div class="d-flex flex-wrap"
                 style="gap:12px;">
                @for (organization of organizations(); track $index) {
                    <div style="flex: 0 0 47%; max-width:47%">
                        <pmis3-vessel-visit-detail-organization [organization]="organization"
                                                                (deletedOrganization)="onDeletedOrganizationFromChild($event)">
                        </pmis3-vessel-visit-detail-organization>
                    </div>
                }
                <div style="flex: 0 0 47%; max-width:47%">
                    <pmis3-vessel-visit-detail-organization (assignedOrganization)="onAssignedOrganizationFromChild($event)"
                                                            (deletedOrganization)="onDeletedOrganizationFromChild($event)">
                    </pmis3-vessel-visit-detail-organization>
                </div>
            </div>
        </div>
    </div>
    <div class="row mx-0">
        <div class="col-2">
            <div class="border border-radius-8"
                 style="display:grid; gap:12px;  grid-template-columns: auto auto; padding:12px">
                <div style="grid-column: 1 / span 2;">
                    <h6 class="m-0">DRAFT</h6>
                </div>
                <div>
                    <kendo-label [text]="'Fwd'"
                                 class="text-grey">
                        <kendo-numerictextbox [spinners]="false"
                                              [value]="vesselActivitiesPair().movement.foreDraft"
                                              (valueChange)="onFwdDraftChange($event)"
                                              [fillMode]="'outline'"></kendo-numerictextbox>
                    </kendo-label>
                </div>
                <div>
                    <kendo-label [text]="'Aft'"
                                 class="text-grey">
                        <kendo-numerictextbox [spinners]="false"
                                              [value]="vesselActivitiesPair().movement.aftDraft"
                                              (valueChange)="onAftDraftChange($event)"
                                              [fillMode]="'outline'"></kendo-numerictextbox>
                    </kendo-label>
                </div>
                <div>
                    <kendo-label [text]="'Air Draft'"
                                 class="text-grey">
                        <kendo-numerictextbox [spinners]="false"
                                              [value]="vesselActivitiesPair().movement.airDraft"
                                              (valueChange)="onAirDraftChange($event)"
                                              [fillMode]="'outline'"></kendo-numerictextbox>
                    </kendo-label>
                </div>
                <div>
                    <kendo-label [text]="'Mid Draft'"
                                 class="text-grey">
                        <kendo-numerictextbox [spinners]="false"
                                              [value]="vesselActivitiesPair().movement.midDraft"
                                              (valueChange)="onMidDraftChange($event)"
                                              [fillMode]="'outline'"></kendo-numerictextbox>
                    </kendo-label>
                </div>
            </div>
        </div>
        <div class="col">
            <kendo-label [text]="'Remarks'"
                         class="text-grey">
                <kendo-textarea [rows]="7"
                                [fillMode]="'outline'"
                                class="w-100 line-height-1-half"></kendo-textarea>
            </kendo-label>
        </div>
    </div> -->
<!-- </div> -->